import { Chip, styled } from '@mui/material';

const Color = ({ theme, color, variant, shade, transparency, matchText }) => {
    if (matchText) {
        return theme.palette[color].dark;
    }
    if (variant === 'outlined') {
        return theme.palette.text.primary;
    }
    if (variant === 'filled') {
        if (color === 'yellow') return theme.palette.text.primary;
        if (transparency > 0.5) return theme.palette.text.primary;
        return theme.palette[color].contrastText;
    }

    return theme.palette[color][shade];
};

const Opacity = {
    solid: 0.0,
    faded: 0.7,
    echo: 0.9,
    clear: 1.0,
    clearWhite: 2.0,
};

const FilterProps = (prop) => {
    switch (prop) {
        case 'shade':
        case 'backgroundOpacity':
        case 'matchText':
        case 'round':
        case 'bordered':
        case 'fullWidth':
            return false;
        default:
            return true;
    }
};

const LiquidChip = styled(Chip, {
    shouldForwardProp: FilterProps,
})(
    ({
        theme, //
        color = 'primary',
        variant = 'filled',
        shade = 'main',
        backgroundOpacity,
        matchText = true,
        round = true,
        bordered = false,
        fullWidth = false,
    }) => {
        const transparency = Opacity[backgroundOpacity] ?? Opacity.clear;
        const safeColor = Object.keys(theme.palette).includes(color) ? color : 'primary';
        const clearColor = { clear: 'transparent', clearWhite: 'rgba(255, 255, 255, 1.0)' }[backgroundOpacity];
        const backgroundColor = clearColor ?? `linear-gradient(0deg, rgba(255, 255, 255, ${transparency}), rgba(255, 255, 255, ${transparency})), ${theme.palette[safeColor][shade]}`;
        return {
            background: backgroundColor,
            color: Color({ theme, color: safeColor, variant, shade, transparency, matchText }),
            border: bordered ? `2px solid ${theme.palette[safeColor][shade]}` : 'none',
            width: fullWidth ? '100%' : 'auto',
            borderRadius: round ? '20px' : '4px',
            fontWeight: 600,
        };
    }
);

export default LiquidChip;
